import { useCallback } from "react";

import { API_BASE_URL } from "@/api/api.config";
import useRestMutation from "@/remoteState/useRestMutation";

const useSessionPost = () => {
  const createSession = useCallback((payload) => {
    return new Request(`${API_BASE_URL}/api/v2/session/`, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: { "Content-Type": "application/json" },
    });
  }, []);

  return useRestMutation(createSession);
};

export default useSessionPost;
